import { render, staticRenderFns } from "./AppIShow.vue?vue&type=template&id=3713c05a&scoped=true&"
var script = {}
import style0 from "./AppIShow.vue?vue&type=style&index=0&id=3713c05a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3713c05a",
  null
  
)

export default component.exports